<div role="navigation"
     [attr.aria-label]="'tdWb.menu.LOCAL' | translate">
  <h2 id="td-wb-aria-local-nav-header"
      class="td-wb-vh"
      translate="tdWb.menu.LOCAL_HEADER">
  </h2>
  <div class="td-wb-menu-local-navigation-container">
    <div [class]="getFlyoutClass()">
      <td-wb-menu-item class="td-wb-nav__secondary__item td-wb-nav__secondary__item--logo">
        <a class="td-wb-menu__logo"
           role="link"
           tabindex="0"
           [attr.href]="logoUrl"
           [attr.aria-label]="logoLabelTranslationId | translate">
          <td-wb-icon size="35x31" iconId="logo--td"/>
        </a>
      </td-wb-menu-item>
      @for (item of navigationMenu().localNavigation; track item) {
        <td-wb-menu-item
          [menuItem]="item"
          [flyoutType]="flyoutType()"
          [activeItemId]="getActiveItemId()">
          <td-wb-menu-item-toggle iconId="caret--down"
                                  size="14"
                                  [flyoutType]="flyoutType()"/>
          @if (hasFlyOut(item) && item.open) {
            <td-wb-menu-item-content [flyoutType]="flyoutType()"
                                     [singleColumn]="item.menu[0].item !== undefined && item.menu[0].item.length === 1">
              @if (item.menu[0].item !== undefined && item.menu[0].item.length > 1) {
                @for (group of item.menu[0].item; track trackByIndex($index)) {
                  @if (showSecondaryContentColumn(item.menu, group)) {
                    <div class="td-wb-nav-secondary-content-col">
                      @if (group.icon) {
                        <div class="td-wb-flyout-menu__item-image">
                          <a [href]="group.href"
                             [style.width]="group.icon.width + 'px'"
                             [attr.target]="group.target">
                            <img [src]="group.icon.url"
                                 [width]="group.icon.width"
                                 [height]="group.icon.height"
                                 [alt]="group.icon.altText"/>
                          </a>
                        </div>
                      }
                      @if (!group.icon) {
                        <span class="td-wb-flyout-menu__item-header"
                              [innerHtml]="group.text">
                          </span>
                      }
                      @if (!group.icon && group.menu) {
                        @for (link of group.menu[0].item; track link) {
                          <a role="button"
                             class="td-wb-flyout-menu__item"
                             [href]="link.href"
                             [attr.target]="link.target"
                             [attr.id]="'td-wb-top-navigation__content__item-' + link.id">
                            <span [innerHtml]="link.text"></span>
                            @if (showNewBadge(link.href)) {
                              <td-wb-badge class="td-wb-menu-local-navigation__item-badge"
                                           [text]="'tdWb.menu.badge.NEW' | translate"
                                           size="extra-small"
                                           colour="accent"/>
                            }
                            @if (isExternalLink(link)) {
                              <td-wb-icon iconId="new-page"
                                          size="14"/>
                            }
                          </a>
                        }
                      }
                    </div>
                  }
                }
              }
              @if (item.menu[0].item !== undefined && item.menu[0].item.length === 1) {
                @if (item.menu[0].item[0]; as group) {
                  <div class="td-wb-nav-secondary-content-col--single">
                    @for (link of group.menu[0].item; track link) {
                      <a role="button"
                         class="td-wb-flyout-menu__item"
                         [attr.target]="link.target"
                         [attr.id]="'td-wb-top-navigation__content__item-' + link.id"
                         [href]="link.href">
                        <span [innerHtml]="link.text"></span>
                      </a>
                    }
                  </div>
                }
              }
            </td-wb-menu-item-content>
          }
        </td-wb-menu-item>
      }
      <td-wb-menu-item>
        <td-wb-menu-search-navigation class="td-wb-menu-search-navigation"/>
      </td-wb-menu-item>
    </div>

    <td-wb-menu-toolbar class="td-wb-menu-local-navigation__toolbar"/>
  </div>
</div>
